import * as React from 'react';
import * as cn from 'classnames';

import { PlayBtn } from '../../Icons';

import * as styles from './styles.css';

interface IProps {
  hidden: boolean;
  openVideo(): void;
}

export const VideoOverlay: React.FC<IProps> = ({ hidden, openVideo }) => {
  return (
    <React.Fragment>
      <div className={cn(styles['play-btn-container'], hidden && styles['hidden'])}>
        <div onClick={openVideo}>
          <PlayBtn className={styles['play-btn']} />
        </div>
      </div>

      <div className={cn(styles['overlay'], hidden && styles['hidden'])} />
    </React.Fragment>
  );
};

VideoOverlay.displayName = 'VideoOverlay';
